import './SolutionsFinance.css';
import housePhoto from '../../assets/house_full_battery.png';
import savesUnderline from '../../assets/figma_saves_underline.svg';
import purpleEastLogo from '../../assets/purple_east_finance_logo.jpg';

export default function SolutionsFinance() {
  return (
    <section className="sf-section">
      <div className="sf-inner">

        <div className="sf-header">
          <p className="sf-eyebrow">FINANCE PARTNER</p>
          <h2 className="sf-heading">
            Flexible Finance Options<br/>
            To Power{' '}
            <span className="sf-heading-highlight">
              Your Home
              <img src={savesUnderline} alt="" className="sf-heading-stroke" />
            </span>
          </h2>
          <p className="sf-body">We've partnered with trusted finance providers to make solar and battery solutions more affordable and accessible.</p>
        </div>

        <div className="sf-card">
          <div className="sf-card-main">

            {/* Dark left panel: photo + features */}
            <div className="sf-left">
              <div className="sf-photo">
                <img src={housePhoto} alt="Solar home with battery" />
              </div>
              <div className="sf-features">
                <h3 className="sf-partner-heading">Our Finance Partner</h3>
                <p className="sf-partner-intro">
                  We've partnered with <strong>Purple East Finance</strong> to make solar and battery systems more affordable.
                </p>
              </div>
            </div>

            {/* White right panel: partner info */}
            <div className="sf-right">
              <div className="sf-partner-logo">
                <img src={purpleEastLogo} alt="Purple East Finance" className="sf-partner-logo-img" />
              </div>
              <p className="sf-partner-desc">Purple East Finance helps Melbourne homeowners access flexible finance options for solar and battery systems.</p>
              <a href="/contact" className="sf-cta-btn">
                Learn More <span>→</span>
              </a>
            </div>

          </div>

          {/* Bottom trust bar */}
          <div className="sf-trust-bar">
            <div className="sf-trust-item">
              <div className="sf-trust-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/>
                  <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="1.7"/>
                  <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/>
                </svg>
              </div>
              <p>Trusted by hundreds of VIC households to <strong>make the switch to clean energy.</strong></p>
            </div>
            <div className="sf-trust-sep" />
            <div className="sf-trust-item">
              <div className="sf-trust-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.35C17.25 22.15 21 17.25 21 12V7l-9-5z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/>
                  <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <p>Secure, transparent and trusted <strong>finance you can count on.</strong></p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
